module.exports = __webpack_public_path__ + "img/clinic-facade.7c4681fe.svg";